<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <!--  Banner Starts Here   -->
    <div class="inner_banner">
      <div class="container_large">
        <h1>Verify Email</h1>
      </div>
    </div>
    <!--  Banner Ends Here   -->

    <!--   Main Content Start Here   -->
    <main>
      <section class="inner_wraper full_bg">
        <div class="container_large"></div>
      </section>
    </main>
  </div>
</template>
<script>
 
import validationErrors from "../../mixins/validationErrors";
import { is422 } from "../../utils/response";
import usersApis from "../../Apis/users";
import { logIn, getCurrentUser, setCurrentUser, loginAdmin } from "../../utils/auth";
export default {
  async created() {
    const data = await usersApis.verifyEmail(this.$route.params.id);
    if (data && data.status && data.status == 200) {
      logIn();
      setCurrentUser(data.data);
      this.$store.dispatch("islogedIn", data.data);
      this.loader = false;
      this.$router.push({ name: "order" });
      //  this.$router.push({name:'login'});
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Auth/verifyEmail.vue